/**
 * 
 */

// Bootstrap 5 vanilla JS: Document ready replacement
onDocumentReady(function() {
	$("#memberForm").validate({
		  errorPlacement: handleErrorPlacement,
		  rules: {
			  birthDate: {
			      required: true
			  },
			  qualifyDate: {
			      required: true
			  },
			  zipCode: {
			      required: true,
			      minlength: 5
			      },
			  memberId: {
			      required: true,
			      minlength: 6
			  },
			  memberTypeId: {
			      required: true
			  }
		  }
	});	
	
	// Bootstrap 5 vanilla JS: Add click event listeners for table headers
	document.querySelectorAll('thead .loginDate a').forEach(function(element) {
		element.addEventListener('click', function() {
			// Toggle visibility of login date elements
			document.querySelectorAll('td .loginDateToggle').forEach(function(toggle) {
				if (toggle.style.display === 'none' || !toggle.style.display) {
					toggle.style.display = 'block';
				} else {
					toggle.style.display = 'none';
				}
			});
		});
	});			
});

/*,errorPlacement: function(er, el) {
	    if (el && el.length > 0) 
	    	createErrorBubble( $(el), er.text(), 'right');
}*/

function createErrorBubble(element, text, position) {
	if( position === undefined)
		position = 'right';
	
    // In a conversation with pcobar the spec was changed for the bubbles to be to the right of the element
    createBubble(element, text, 2, "none", position, "#fe0000", "#b2cedc", "#ffffff", true);
    element.btOn();
}

function createBubble(element, content, messageType, trigger, positions, fillColor, strokeColor, foreColor, useShadow) {
    var btInstance = element.bt( content,{
        trigger: trigger,
        positions: positions,
        shrinkToFit: true,
        spikeLength: 12,
        showTip: function (box) {
            $(box).fadeIn(100);
        },
        hideTip: function (box, callback) {
            $(box).animate({ opacity: 0 }, 100, callback);
        },
        fill: fillColor,
        strokeStyle: strokeColor,
        shadow: useShadow,
        clickAnywhereToClose: false,
        closeWhenOthersOpen: false, // Closing when others open hides page validation errors. This should be false.
        preShow: function (box) {
            if (messageType != 1) return;

            var whiteboard = $($(box).children()[0]);
            var content = whiteboard.html();

            if (content.substr(0, 5).toLowerCase() == "<div>") {
                content = content.substr(5, content.length -11);
            }

            whiteboard.html('<div><span class="helpWarningPrefix">Warning:</span> ' + content + "</div>");
        },
        cssStyles: { color: foreColor },
        textzIndex: 12, // z-index for the text
        boxzIndex: 11, // z-index for the "talk" box (should always be less than textzIndex)
        wrapperzIndex: 10
    });
}

function getAge(birthDate) {
	var now = new Date();

	function isLeap(year) {
		return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
	}

	// days since the birthdate    
	var days = Math.floor((now.getTime() - birthDate.getTime()) / 1000 / 60	/ 60 / 24);
	var age = 0;
	// iterate the years
	for ( var y = birthDate.getFullYear(); y <= now.getFullYear(); y++) {
		var daysInYear = isLeap(y) ? 366 : 365;
		if (days >= daysInYear) {
			days -= daysInYear;
			age++;
			// increment the age only if there are available enough days for the year.
		}
	}
	return age;
}

function setGenderImage(imagePath) {
	var male = "<img src='" + imagePath + "/icon_genderMale.png' alt='Male' title='Gender'/>";
	var female = "<img src='" + imagePath + "/icon_genderFemale.png' alt='Female' title='Gender'/>";
	
	$( "span.gender" ).each( function(){
		if( $(this).text() === 'FEMALE' )
			$(this).html( female );
		else
			$(this).html( male );
	});
}	


/* createErrorBubble usage..
	$("#formName").validate({
	    errorPlacement: function(error, element) {
	    	if (element && element.length > 0) 
	            createErrorBubble($(element), error.text());
	    }
	});
*/


/* old stuff - don't delete just yet
	Ajax delete animation

$("img[alt=Delete]").parent().click(function(e){
	e.preventDefault();
	var row = $(this).closest('tr');
	var statusId = $(this).closest('tr').attr('data-id');
	var caseInfoId = '<c:out value="${caseinfo.uniqueId}"/>';
	var statusElement = "#status_" + statusId + " td";
	
	$(statusElement).animate({'backgroundColor':'#fb6c6c'},300);	
	
	var wait = setInterval(function() {
		if( !$(statusElement).is(":animated") ) {
			clearInterval(wait);
			
			$.ajax({
				type : 'post',
				url : '${pageContext.request.contextPath}/eapp/proposal/delete',
				data : 'ajax=1&statusId=' + statusId + '&caseInfoId=' + caseInfoId,
				beforeSend : function() {
					if (confirm("Continue to delete the status?"))
						return true;
					else {
						if ($(statusElement).length > 0)
							$(statusElement).animate({
								'backgroundColor' : '#ffffff'
							}, 300);

						return false;
					}
				},
				success : function() {
				    $(row).children().wrapInner('<div>').children().slideUp(function() {    
				        $(this).closest('tr').remove();
				    });
				    
					var $hiddenInput = $('<input/>',{type:'hidden', name:'status_id', value:statusId});
					$hiddenInput.appendTo( '#proposalForm' );	
				}
			});				
		}
	}, 100);

});
 
*/